const ZeldaLTTP = {
    "zelda-lttp-bottle":{
        "type":"png",
        "upgrades":4,
        "content":"zelda-lttp/bottle0",
        "active":"zelda-lttp/bottle1",
        "up2":"zelda-lttp/bottle2",
        "up3":"zelda-lttp/bottle3",
        "up4":"zelda-lttp/bottle4",
        "nicename": "Zelda - LttP - Bottle"
    },
    "zelda-lttp-bomb":{
        "type":"png",
        "upgrades":2,
        "content":"zelda-lttp/bomb1",
        "up2":"zelda-lttp/bomb2",
        "nicename": "Zelda - LttP - Bomb"
    },
    "zelda-lttp-book":{
        "type":"png",
        "content":"zelda-lttp/book",
        "nicename": "Zelda - LttP - Book"
    },
    "zelda-lttp-boomerang":{
        "type":"png",
        "upgrades":3,
        "content":"zelda-lttp/boomerang1",
        "up2":"zelda-lttp/boomerang2",
        "up3":"zelda-lttp/boomerang3",
        "nicename": "Zelda - LttP - Boomerang"
    },
    "zelda-lttp-boots":{
        "type":"png",
        "content":"zelda-lttp/boots",
        "nicename": "Zelda - LttP - Boots"
    },
    "zelda-lttp-boss1":{
        "type":"png",
        "content":"zelda-lttp/boss_1",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss2":{
        "type":"png",
        "content":"zelda-lttp/boss_2",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss3":{
        "type":"png",
        "content":"zelda-lttp/boss_3",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss4":{
        "type":"png",
        "content":"zelda-lttp/boss_4",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss5":{
        "type":"png",
        "content":"zelda-lttp/boss_5",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss6":{
        "type":"png",
        "content":"zelda-lttp/boss_6",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss7":{
        "type":"png",
        "content":"zelda-lttp/boss_7",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss8":{
        "type":"png",
        "content":"zelda-lttp/boss_8",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss9":{
        "type":"png",
        "content":"zelda-lttp/boss_9",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss10":{
        "type":"png",
        "content":"zelda-lttp/boss_10",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss11":{
        "type":"png",
        "content":"zelda-lttp/boss_11",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss12":{
        "type":"png",
        "content":"zelda-lttp/boss_12",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-boss13":{
        "type":"png",
        "content":"zelda-lttp/boss_13",
        "nicename": "Zelda - LttP - Boss - 1"
    },
    "zelda-lttp-bow":{
        "type":"png",
        "content":"zelda-lttp/bow",
        "nicename": "Zelda - LttP - Bow"
    },
    "zelda-lttp-byrna":{
        "type":"png",
        "content":"zelda-lttp/byrna",
        "nicename": "Zelda - LttP - Byrna"
    },
    "zelda-lttp-cape":{
        "type":"png",
        "content":"zelda-lttp/cape",
        "nicename": "Zelda - LttP - Cape"
    },
    "zelda-lttp-firerod":{
        "type":"png",
        "content":"zelda-lttp/firerod",
        "nicename": "Zelda - LttP - Fire Rod"
    },
    "zelda-lttp-flippers":{
        "type":"png",
        "content":"zelda-lttp/flippers",
        "nicename": "Zelda - LttP - Flippers"
    },
    "zelda-lttp-flute":{
        "type":"png",
        "upgrades":3,
        "content":"zelda-lttp/flute0",
        "up2":"zelda-lttp/flute1",
        "up3":"zelda-lttp/flute2",
        "nicename": "Zelda - LttP - Flute"
    },
    "zelda-lttp-glove":{
        "type":"png",
        "upgrades":2,
        "content":"zelda-lttp/glove1",
        "up2":"zelda-lttp/glove2",
        "nicename": "Zelda - LttP - Flute"
    },
    "zelda-lttp-hammer":{
        "type":"png",
        "content":"zelda-lttp/hammer",
        "nicename": "Zelda - LttP - Hammer"
    },
    "zelda-lttp-heartcontainer":{
        "type":"png",
        "content":"zelda-lttp/heartcontainer",
        "nicename": "Zelda - LttP - Heart Container"
    },
    "zelda-lttp-heartpiece":{
        "type":"png",
        "content":"zelda-lttp/heartpiece",
        "nicename": "Zelda - LttP - Heart Piece"
    },
    "zelda-lttp-hookshot":{
        "type":"png",
        "content":"zelda-lttp/hookshot",
        "nicename": "Zelda - LttP - Hookshot"
    },
    "zelda-lttp-icerod":{
        "type":"png",
        "content":"zelda-lttp/icerod",
        "nicename": "Zelda - LttP - Icerod"
    },
    "zelda-lttp-lantern":{
        "type":"png",
        "content":"zelda-lttp/lantern",
        "nicename": "Zelda - LttP - Lantern"
    },
    "zelda-lttp-medallion_bombos":{
        "type":"png",
        "content":"zelda-lttp/medallion_bombos",
        "nicename": "Zelda - LttP - Medallion - Bombos"
    },
    "zelda-lttp-medallion_ether":{
        "type":"png",
        "content":"zelda-lttp/medallion_ether",
        "nicename": "Zelda - LttP - Medallion - Ether"
    },
    "zelda-lttp-medallion_quake":{
        "type":"png",
        "content":"zelda-lttp/medallion_quake",
        "nicename": "Zelda - LttP - Medallion - Quake"
    },
    "zelda-lttp-mirror":{
        "type":"png",
        "content":"zelda-lttp/mirror",
        "nicename": "Zelda - LttP - Mirror"
    },
    "zelda-lttp-moonpearl":{
        "type":"png",
        "content":"zelda-lttp/moonpearl",
        "nicename": "Zelda - LttP - Moonpearl"
    },
    "zelda-lttp-mpupgrade0":{
        "type":"png",
        "upgrades":3,
        "content":"zelda-lttp/mpupgrade0",
        "up2":"zelda-lttp/mpupgrade1",
        "up3":"zelda-lttp/mpupgrade2",
        "nicename": "Zelda - LttP - MP Upgrade"
    },
    "zelda-lttp-mushroom":{
        "type":"png",
        "content":"zelda-lttp/mushroom",
        "nicename": "Zelda - LttP - Mushroom"
    },
    "zelda-lttp-net":{
        "type":"png",
        "content":"zelda-lttp/net",
        "nicename": "Zelda - LttP - Net"
    },
    "zelda-lttp-pendant1":{
        "type":"png",
        "content":"zelda-lttp/pendant1",
        "nicename": "Zelda - LttP - Pendant1"
    },
    "zelda-lttp-pendant2":{
        "type":"png",
        "content":"zelda-lttp/pendant2",
        "nicename": "Zelda - LttP - pendant2"
    },
    "zelda-lttp-pendant3":{
        "type":"png",
        "content":"zelda-lttp/pendant3",
        "nicename": "Zelda - LttP - Pendant3"
    },
    "zelda-lttp-powder":{
        "type":"png",
        "content":"zelda-lttp/powder",
        "nicename": "Zelda - LttP - Powder"
    },
    "zelda-lttp-shield":{
        "type":"png",
        "upgrades":3,
        "content":"zelda-lttp/shield1",
        "up2":"zelda-lttp/shield2",
        "up3":"zelda-lttp/shield3",
        "nicename": "Zelda - LttP - Shield"
    },
    "zelda-lttp-shovel":{
        "type":"png",
        "content":"zelda-lttp/shovel",
        "nicename": "Zelda - LttP - Shovel"
    },
    "zelda-lttp-arrows":{
        "type":"png",
        "upgrades":2,
        "content":"zelda-lttp/woods",
        "up2":"zelda-lttp/silvers",
        "nicename": "Zelda - LttP - Arrows"
    },
    "zelda-lttp-somaria":{
        "type":"png",
        "content":"zelda-lttp/somaria",
        "nicename": "Zelda - LttP - Somaria"
    },
    "zelda-lttp-sword":{
        "type":"png",
        "upgrades":4,
        "content":"zelda-lttp/sword1",
        "up2":"zelda-lttp/sword2",
        "up3":"zelda-lttp/sword3",
        "up4":"zelda-lttp/sword4",
        "nicename": "Zelda - LttP - Sword"
    },
    "zelda-lttp-tumic":{
        "type":"png",
        "upgrades":3,
        "content":"zelda-lttp/tunic1",
        "up2":"zelda-lttp/tunic2",
        "up3":"zelda-lttp/tunic3",
        "nicename": "Zelda - LttP - Tunic"
    },
}
const LLTPSets = {
    'lttp-set':',zelda-lttp-bottle,zelda-lttp-bomb,zelda-lttp-book,zelda-lttp-boomerang,zelda-lttp-boots,|,zelda-lttp-boss1,zelda-lttp-boss2,zelda-lttp-boss3,zelda-lttp-boss4,zelda-lttp-boss5,zelda-lttp-boss6,zelda-lttp-boss7,zelda-lttp-boss8,zelda-lttp-boss9,zelda-lttp-boss10,zelda-lttp-boss11,zelda-lttp-boss12,zelda-lttp-boss13,|,zelda-lttp-bow,zelda-lttp-byrna,zelda-lttp-cape,zelda-lttp-firerod,zelda-lttp-flippers,zelda-lttp-flute,zelda-lttp-glove,zelda-lttp-hammer,zelda-lttp-heartcontainer,zelda-lttp-heartpiece,zelda-lttp-hookshot,zelda-lttp-icerod,zelda-lttp-lantern,zelda-lttp-medallion_bombos,zelda-lttp-medallion_ether,zelda-lttp-medallion_quake,zelda-lttp-mirror,zelda-lttp-moonpearl,zelda-lttp-mpupgrade0,zelda-lttp-mushroom,zelda-lttp-net,zelda-lttp-pendant1,zelda-lttp-pendant2,zelda-lttp-pendant3,zelda-lttp-powder,zelda-lttp-shield,zelda-lttp-shovel,zelda-lttp-arrows,zelda-lttp-somaria,zelda-lttp-sword,zelda-lttp-tumic'
}
export {ZeldaLTTP, LLTPSets};